function isEqualWith(a, b, compare) {
  const pSlice = Array.prototype.slice;
  const Object_keys = typeof Object.keys === "function" ? Object.keys : function(obj) {
    const keys = [];
    for (const key in obj) {
      keys.push(key);
    }
    return keys;
  };
  const deepEqual = function(actual, expected) {
    if (actual === expected) {
      return true;
    } else if (actual instanceof Date && expected instanceof Date) {
      return actual.getTime() === expected.getTime();
    } else if (typeof actual != "object" && typeof expected != "object") {
      return actual == expected;
    } else {
      return objEquiv(actual, expected);
    }
  };
  function isUndefinedOrNull(value) {
    return value === null || value === void 0;
  }
  function isArguments(object) {
    return Object.prototype.toString.call(object) == "[object Arguments]";
  }
  function objEquiv(a2, b2) {
    if (isUndefinedOrNull(a2) || isUndefinedOrNull(b2)) {
      return false;
    }
    if (a2.prototype !== b2.prototype) {
      return false;
    }
    if (isArguments(a2)) {
      if (!isArguments(b2)) {
        return false;
      }
      a2 = pSlice.call(a2);
      b2 = pSlice.call(b2);
      return deepEqual(a2, b2);
    }
    let ka, kb, key, i;
    try {
      ka = Object_keys(a2);
      kb = Object_keys(b2);
    } catch (e) {
      return false;
    }
    if (ka.length != kb.length) {
      return false;
    }
    ka.sort();
    kb.sort();
    for (i = ka.length - 1; i >= 0; i--) {
      if (ka[i] != kb[i]) {
        return false;
      }
    }
    for (i = ka.length - 1; i >= 0; i--) {
      key = ka[i];
      if (compare) {
        let result = compare(a2[key], b2[key], key);
        if (result === void 0) {
          result = isEqualWith(a2[key], b2[key]);
        }
        if (!result) {
          return false;
        }
      } else {
        if (!deepEqual(a2[key], b2[key])) {
          return false;
        }
      }
    }
    return true;
  }
  return deepEqual(a, b);
}
function get(obj, path, defaultValue = void 0) {
  const travel = (regexp) => String.prototype.split.call(path, regexp).filter(Boolean).reduce((res, key) => res !== null && res !== void 0 ? res[key] : res, obj);
  const result = travel(/[,[\]]+?/) || travel(/[,[\].]+?/);
  return result === void 0 || result === obj ? defaultValue : result;
}
function pick(object, keys) {
  return keys.reduce((obj, key) => {
    if (object && object.hasOwnProperty(key)) {
      obj[key] = object[key];
    }
    return obj;
  }, {});
}
function forOwn(object, cb) {
  for (let key in object) {
    if (object.hasOwnProperty(key)) {
      cb(object[key], key);
    }
  }
}
function isObject(object) {
  return typeof object === "object" && object !== null;
}
function isString(str) {
  return str && typeof str.valueOf() === "string" ? true : false;
}
function union(a, b) {
  return [.../* @__PURE__ */ new Set([...a, ...b])];
}
function unionWith(a, b, compare) {
  return [...a, ...b].reduce((p, c) => {
    if (p.findIndex((v) => compare(v, c)) !== -1) {
      return p;
    }
    p.push(c);
    return p;
  }, []);
}
function omitMod(obj, paths) {
  for (let path of paths) {
    if (typeof path === "string") {
      path = path.split(".");
    }
    for (let i = 0; i < path.length - 1; i++) {
      obj = obj[path[i]];
      if (typeof obj === "undefined") {
        continue;
      }
    }
    delete obj[path.pop()];
  }
}
export {
  forOwn,
  get,
  isEqualWith,
  isObject,
  isString,
  omitMod,
  pick,
  union,
  unionWith
};
